import { render, staticRenderFns } from "./IkkatsuExplanationUpload.vue?vue&type=template&id=e927fc00&"
import script from "./IkkatsuExplanationUpload.vue?vue&type=script&lang=ts&"
export * from "./IkkatsuExplanationUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports